import React, { useState, useEffect } from 'react';
import { X, Info } from 'lucide-react';

const NOTICE_KEY = 'portal_pagos_notice_count';
const MAX_SHOWS = 3;

const IntegrationNotice = () => {
  const [visible, setVisible] = useState(false);
  const [showCount, setShowCount] = useState(0);

  useEffect(() => {
    // Verificar cuántas veces se ha mostrado
    const count = parseInt(localStorage.getItem(NOTICE_KEY) || '0', 10);
    
    if (count < MAX_SHOWS) {
      setShowCount(count + 1);
      setVisible(true);
    }
  }, []);

  const getGreeting = () => {
    const hour = new Date().getHours();
    
    if (hour >= 5 && hour < 13) {
      return '¡Buenos días!';
    } else if (hour >= 13 && hour < 21) {
      return '¡Buenas tardes!';
    } else {
      return '¡Buenas noches!';
    }
  };

  const handleDismiss = () => {
    // Guardar que se mostró una vez más
    localStorage.setItem(NOTICE_KEY, showCount.toString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="mb-6 animate-in fade-in slide-in-from-top-2 duration-500">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-2xl p-5 shadow-sm">
        <div className="flex items-start gap-4">
          {/* Icono */}
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
              <Info className="w-5 h-5 text-blue-600" />
            </div>
          </div>
          
          {/* Contenido */}
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-semibold text-gray-800 mb-2">
              {getGreeting()} 👋
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Es un gusto informarte que ahora los <span className="font-medium text-blue-700">pagos a proveedores</span> se 
              registran automáticamente desde el <span className="font-medium text-blue-700">Portal de Pagos</span>. 
              Ya no es necesario que ingreses estos gastos manualmente aquí.
            </p>
            <p className="text-gray-600 text-sm mt-2 leading-relaxed">
              Por favor, continúa reportando tus pagos en el Portal como lo has venido haciendo.
            </p>
            
            {/* Botón y contador */}
            <div className="mt-4 flex items-center justify-between">
              <button
                onClick={handleDismiss}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors duration-200 flex items-center gap-2"
                data-testid="notice-dismiss-btn"
              >
                Entendido
              </button>
              <span className="text-xs text-gray-400 font-medium">
                {showCount}/{MAX_SHOWS}
              </span>
            </div>
          </div>
          
          {/* Botón cerrar (X) */}
          <button
            onClick={handleDismiss}
            className="flex-shrink-0 p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Cerrar"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default IntegrationNotice;
